"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaQueryLabel = exports.canHover = exports.getActiveResponsiveBreakpoint = exports.getActiveBreakpoint = exports.breakpoints = exports.BREAKPOINTS = void 0;
var styled_components_1 = require("styled-components");
var colors = __importStar(require("./colors"));
exports.BREAKPOINTS = {
    small: 0,
    medium: 600,
    large: 960,
    xlarge: 1250,
};
var getMediaQuery = function (min) { return "(min-width: ".concat(min + 1, "px)"); };
exports.breakpoints = {
    small: getMediaQuery(exports.BREAKPOINTS.small - 1),
    medium: getMediaQuery(exports.BREAKPOINTS.medium),
    large: getMediaQuery(exports.BREAKPOINTS.large),
    xlarge: getMediaQuery(exports.BREAKPOINTS.xlarge),
};
var responsiveBreakpoints = {
    small: exports.breakpoints['small'],
    medium: exports.breakpoints['medium'],
    large: exports.breakpoints['large'],
};
var getActiveBreakpoint = function () {
    return Object.entries(exports.breakpoints)
        .reverse()
        .find(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], query = _b[1];
        return window.matchMedia(query).matches;
    })[0];
};
exports.getActiveBreakpoint = getActiveBreakpoint;
var getActiveResponsiveBreakpoint = function () {
    return Object.entries(responsiveBreakpoints)
        .reverse()
        .find(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], query = _b[1];
        return window.matchMedia(query).matches;
    })[0];
};
exports.getActiveResponsiveBreakpoint = getActiveResponsiveBreakpoint;
exports.canHover = "@media(hover: hover) and (pointer: fine)";
var getShowMediaQueryLabel = function () {
    var hasWindow = typeof window !== undefined;
    if (!hasWindow) {
        return false;
    }
    try {
        var showMediaQueryLabel = JSON.parse(window.localStorage.getItem('showMediaQueryLabel'));
        return showMediaQueryLabel ? 'block' : 'none';
    }
    catch (e) {
        return false;
    }
};
exports.mediaQueryLabel = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  body {\n    &:before {\n      content: 'BASE';\n      display: ", ";\n      position: fixed;\n      top: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      background: ", ";\n      color: ", ";\n      font-size: 14px;\n      line-height: 1;\n      pointer-events: none;\n      user-select: none;\n      padding: 0.5em 1em;\n      border-bottom-left-radius: 0.25em;\n      border-bottom-right-radius: 0.25em;\n      text-transform: uppercase;\n      font-weight: bold;\n      z-index: 10000000;\n\n      ", "\n    }\n  }\n"], ["\n  body {\n    &:before {\n      content: 'BASE';\n      display: ", ";\n      position: fixed;\n      top: 0;\n      left: 50%;\n      transform: translateX(-50%);\n      background: ", ";\n      color: ", ";\n      font-size: 14px;\n      line-height: 1;\n      pointer-events: none;\n      user-select: none;\n      padding: 0.5em 1em;\n      border-bottom-left-radius: 0.25em;\n      border-bottom-right-radius: 0.25em;\n      text-transform: uppercase;\n      font-weight: bold;\n      z-index: 10000000;\n\n      ", "\n    }\n  }\n"])), getShowMediaQueryLabel(), colors.RED_50, colors.WHITE, Object.keys(exports.breakpoints).map(function (key) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          @media ", " {\n            content: '", "';\n          }\n        "], ["\n          @media ", " {\n            content: '", "';\n          }\n        "])), exports.breakpoints[key], key); }));
var templateObject_1, templateObject_2;
